import React, { useEffect, useState } from "react";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import Select from "../../Common/FormElements/Select/Select";
import Separator from "../../Common/Separator/Separator";
import PassswordInput from "../../Common/Forms/ResetPassword/PassswordInput";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { prospectUserForm, updateProspectUserForm } from "./data";

function ProspectInformationForm({
  isUpdating,
  formData,
  setFormData,
  setDisabled,
  customErrors,
  setCustomErrors,
}) {
  const { t } = useTranslation("common");
  const [invalidFields, setInvalidFields] = useState([]);
  const { user } = useSelector((state) => state.userReducer);

  const currForm = isUpdating ? updateProspectUserForm : prospectUserForm;
  const errorsMap = {
    exist: t("This email is already in use."),
    phoneNumberError: t("Please enter a valid phone number."),
    emailError: t("Please enter a valid email."),
  };
  const checkFormValidation = () => {
    const updatedInvalidFields = [];

    currForm.forEach(({ name, type, required }) => {
      const value = formData[name];

      if (name === "password") {
        if (!isUpdating) {
          if (!value || !String(value).trim().length) {
            updatedInvalidFields.push(name);
          }
        } else {
          if (value && String(value).trim().length > 0) {
            if (String(value).trim().length < 6) {
              updatedInvalidFields.push(name);
            }
          }
        }
        return;
      }

      if (required) {
        if (type === "select") {
          if (value?.code === undefined || value?.code === null) {
            updatedInvalidFields.push(name);
          }
        } else if (
          value === undefined ||
          value === null ||
          !(String(value).trim().length > 0)
        ) {
          updatedInvalidFields.push(name);
        }
      }
    });

    setDisabled(updatedInvalidFields.length > 0);
    setInvalidFields(updatedInvalidFields);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (customErrors && customErrors[name]) {
      setCustomErrors((state) => {
        const updatedState = state;
        if (updatedState[name]) {
          delete updatedState[name];
        }
        return updatedState;
      });
    }
  };

  useEffect(() => {
    checkFormValidation();
  }, [formData]);

  return (
    <div className="modalContent px-5 pt-4">
      <Row>
        {currForm.map((el) => {
          if (el?.type === "select") {
            return (
              <Col lg={el?.span ?? 6} key={el.name} className="mb-4">
                <p className="f16 text-ultraBlack mb-2">
                  {t(`${el.label ?? 3}`)}
                </p>
                <Select
                  {...el}
                  placeholder={t(`${el.placeholder ?? ""}`)}
                  value={formData[el.name]}
                  callback={handleChange}
                />
              </Col>
            );
          }

          return (
            <Col
              lg={el?.span ?? 6}
              key={el.name}
              className={`${
                customErrors && customErrors[el?.name] ? "mb-2" : "mb-4"
              }`}
            >
              {el?.separator && (
                <div className="mb-3">
                  <Separator />
                </div>
              )}
              <p className="f16 text-ultraBlack mb-2">
                {t(`${el.label ?? ""}`)}
              </p>
              {el?.type !== "password" ? (
                <TextInput
                  {...el}
                  placeholder={t(`${el.placeholder ?? ""}`)}
                  value={formData[el?.name]}
                  callback={handleChange}
                />
              ) : (
                ((isUpdating && user?.attributes?.userRole === 1) ||
                  !isUpdating) && (
                  <>
                    <Separator className="my-3" />
                    <PassswordInput
                      {...el}
                      value={formData[el?.name]}
                      callback={handleChange}
                      text={t("Password")}
                    />
                  </>
                )
              )}
              {customErrors &&
                errorsMap.hasOwnProperty(customErrors[el?.name]) && (
                  <div className="mt-2 text-redCalendar f14">
                    {errorsMap[customErrors[el?.name]]}
                  </div>
                )}
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

export default ProspectInformationForm;
